import numeral from 'numeral';

export default function () {
    numeral.register("locale", "to-to", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        currency: {
            symbol: "T$"
        }
    })
}